import { IRootState } from '../../../../store'
import { IQaAddendumState, IQaFlagDetail } from '../store/qaAddendum.types'

export const getQaAddendumSelector = (state: IRootState): IQaAddendumState => state.qaAddendum

export const getSelectedFlagIdSelector = (state: IRootState): string | null => state.qaAddendum.selectedFlagId

export const getSelectedFlagDetailSelector = (state: IRootState): IQaFlagDetail | null =>
  state.qaAddendum.selectedFlagDetail
